import { render, staticRenderFns } from "./ThreeDManagement.vue?vue&type=template&id=1f368e5b&scoped=true"
import script from "./ThreeDManagement.vue?vue&type=script&lang=js"
export * from "./ThreeDManagement.vue?vue&type=script&lang=js"
import style0 from "./ThreeDManagement.vue?vue&type=style&index=0&id=1f368e5b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f368e5b",
  null
  
)

export default component.exports